import { z } from 'zod';
import { dateTimeSchema, uidSchema } from './shared';

export const bidSchema = z.object({
  id: z.string().optional(), // not on doc but is returned from snapshot
  auto: z.boolean().default(false),
  bid_price: z.number().gt(0),
  created: dateTimeSchema,
  max_bid: z.number().optional(),
  offer_id: z.string().min(1),
  product_id: z.string().min(1),
  uid: uidSchema,
  username: z.string().length(5),
});
export interface BidDocument extends z.output<typeof bidSchema> {}
